import CompanyLogo from "@components/company_logo.tsx";
import { Body, SecondaryBody, SectionTitle } from "@sprout/typography.tsx";
import { Tag } from "@sprout/tag.tsx";
import Button from "@sprout/button.tsx";
import PreviewIcon from "@sprout/icons/preview.tsx";
import useTranslation from "@hooks/use_translation.ts";

interface Props {
  title: string;
  company: string;
  logoUrl: string;
  location: string;
  payRange: string;
  publishedAt: string;
  url: string;
}

export const SearchResultCard = ({
  title,
  company,
  logoUrl,
  location,
  payRange,
  publishedAt,
  url,
}: Props) => {
  const { t } = useTranslation("jobSearch");

  return (
    <div className="flex flex-col max-w-128 p-6 gap-4 border-2 rounded-lg border-solid border-gray-00  bg-white">
      <div className="flex flex-row items-center gap-2">
        <CompanyLogo companyName={company} logoUrl={logoUrl} />
        <div className="flex flex-col">
          <SectionTitle>{title}</SectionTitle>
          <Body>{company}</Body>
        </div>
      </div>
      <div className="flex flex-row gap-4">
        <Tag label={location} />
        <Tag label={payRange} />
      </div>
      <div className="flex flex-row items-center justify-between">
        <SecondaryBody>{publishedAt}</SecondaryBody>
        <Button link href={url} external={true}>
          <div className="flex flex-row gap-4 items-center justify-between">
            {t("viewJob")}
            <PreviewIcon color="green" />
          </div>
        </Button>
      </div>
    </div>
  );
};
